import {inject,Injectable,PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser,DOCUMENT} from '@angular/common';
import {SwUpdate,VersionEvent} from '@angular/service-worker';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
	providedIn:'root'
})
export class SwUpdateService{
	private readonly platformId=inject(PLATFORM_ID);
	private readonly document=inject(DOCUMENT);
	private readonly swUpdate=inject(SwUpdate,{optional:true});
	private readonly matSnackBar=inject(MatSnackBar);

	initialize():void{
		if(!isPlatformBrowser(this.platformId)||!this.swUpdate?.isEnabled){
			return;
		}

		this.swUpdate.versionUpdates.subscribe((event:VersionEvent)=>{
			switch(event.type){
				case 'VERSION_READY':{
					const snackBarRef=this.matSnackBar.open(
						$localize`:@@sw-update-available|Snackbar shown when a new app version is ready:Nueva versión disponible`,
						$localize`:@@sw-update-action|Action button that reloads the page to apply the new version:Actualizar`,
						{duration:0}
					);
					snackBarRef.onAction().subscribe(()=>{
						this.document.defaultView?.location.reload();
					});
					break;
				}
				case 'VERSION_INSTALLATION_FAILED':{
					console.error('Service worker version installation failed:',event.error);
					break;
				}
			}
		});
	}
}
